import { CompassUserContext } from '@orientaction/Context';
import { useCompassMenu } from '@orientaction/hooks';
import {
  getCompassTestVisibility,
  NEEDS_TEST_SERVICE_IDS,
  userHasAnyService,
} from '@orientaction/utils';
import { useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

export const useAdminCompassPage = () => {
  const { year }: any = useParams();
  const { userInfos, loading: userLoading } = useContext<any>(CompassUserContext);
  const { getUserData, loading, harmonyTestLastResult, token } = useCompassMenu();
  const getUserDataRef = useRef(getUserData);

  useEffect(() => {
    getUserDataRef.current = getUserData;
  }, [getUserData]);

  useEffect(() => {
    if (year && token && !Number.isNaN(Number(year))) {
      getUserDataRef.current();
      window.scrollTo(0, 0);
    }
  }, [token, year]);

  const isNonRattachedBeneficiary = !userInfos?.rattachement;
  const canAccessNeeds =
    userHasAnyService(userInfos, NEEDS_TEST_SERVICE_IDS) || isNonRattachedBeneficiary;

  const { showNeeds, showNeedsPro } = getCompassTestVisibility(userInfos);

  return {
    loading: loading || userLoading,
    harmonyTestLastResult,
    canAccessNeeds,
    showNeeds,
    showNeedsPro,
  };
};
